import React from 'react';
import Modal from './Modal';
import GhostButton from './GhostButton';

export default function ConfirmModal({ title, message, confirmLabel = 'Delete', onConfirm, onClose }) {
  return (
    <Modal title={title} onClose={onClose} maxWidth="max-w-sm">
      <p className="text-sm mb-6" style={{ color: '#9ca3af' }}>{message}</p>
      <div className="flex justify-end gap-2">
        <GhostButton onClick={onClose}>Cancel</GhostButton>
        <button
          onClick={onConfirm}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
          style={{ backgroundColor: '#dc2626', color: '#fff' }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#b91c1c'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#dc2626'; }}
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
